module.exports = __webpack_public_path__ + "static/media/04.e09638de.png";